import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *助教列表
 * @param params
 * 
*/

export const assistantList = params => Http.get(`${baseUrl}/assistant`, { params } )


/**
 *新增助教
 * @param params
 * 
*/

export const addAssistant = params => Http.post(`${baseUrl}/assistant/${params.classId}`, params.ids )

/**
 *删除助教
 * @param assistantIds
 * 
*/

export const delAssistant = assistantIds => Http.delete(`${baseUrl}/assistant/${assistantIds}` )

/**
 *权限列表信息
 * @param assistantId
 * 
*/

export const assistantPermission = assistantId => Http.get(`${baseUrl}/assistant/${assistantId}/permission` )

/**
 *修改权限
 * @param params
 * 
*/

export const editAssistantPermission = params => Http.put(`${baseUrl}/assistant/${params.assistantId}/permission`, params.list )
